@if (isAuthenticated()) {
  <app-side-nav-outer-toolbar title="{{appInfo.title}}">
    <div [@routeAnimations]="getRouterDataText()">
      <router-outlet></router-outlet>
    </div>
    <app-footer>
      Copyright © 2022-{{appInfo.currentYear}} {{appInfo.company}} v{{appInfo.version}}
    </app-footer>
  </app-side-nav-outer-toolbar>
} @else {
  <app-unauthenticated-content></app-unauthenticated-content>
}

